import { render, staticRenderFns } from "./bankcard.vue?vue&type=template&id=af45eeea&scoped=true&"
import script from "./bankcard.vue?vue&type=script&lang=js&"
export * from "./bankcard.vue?vue&type=script&lang=js&"
import style0 from "./bankcard.vue?vue&type=style&index=0&id=af45eeea&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af45eeea",
  null
  
)

export default component.exports